import { get, post, put } from './_httpClient';

export async function getBatches({
  q = '', page = 1, pageSize = 10, thirdTierProgramId = '',
}) {
  const { status, message, data } = await get(
    `/batch/list?q=${q}&page=${page}&pageSize=${pageSize}&thirdTierProgramId=${thirdTierProgramId}`,
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBatchById({ id }) {
  const { status, message, data } = await get(`/batch/detail/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addBatch(payload) {
  const { status, message, data } = await post('/batch/create', payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateBatch({ id, payload }) {
  const { status, message, data } = await put(`/batch/update/${id}`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getThirdTierProgramOptions() {
  const { status, message, data } = await get('/batch/third-tier-programs');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBatchMainOptions() {
  const { status, message, data } = await get('/batch/batch-main-options');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getStatusAcceptanceConfig({ batchId }) {
  const { status, message, data } = await get(`/batch/${batchId}/status-acceptance`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function upsertStatusAcceptanceConfig({ batchId, statuses }) {
  const { status, message, data } = await put(`/batch/${batchId}/status-acceptance`, { statuses });
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBatchDocumentTemplate({ batchId }) {
  const { status, message, data } = await get(`/batch/${batchId}/document-template`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateBatchDocumentTemplate({ batchId, payload }) {
  const { status, message, data } = await put(`/batch/${batchId}/document-template`, payload);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
